export default __webpack_public_path__ + "static/media/pfr4.a30adb79.png";